import { defineMessages } from 'react-intl';

/**
 * The copy of "Add my song" (design: onboarding c1-c4, copy table in
 * docs/superpowers/design-reference/music24-onboarding/README.md). Product copy, not ASD-STE100.
 */
export const addSongMessages = defineMessages({
  crumb: { id: 'app.sml.addSong.crumb', defaultMessage: 'Add my song' },
  searchLabel: { id: 'app.sml.addSong.search.label', defaultMessage: 'Paste a link or search for the song' },
  searchGroup: { id: 'app.sml.addSong.search.group', defaultMessage: 'Songs by {artist}' },
  pick: { id: 'app.sml.addSong.pick', defaultMessage: 'Pick' },
  picked: { id: 'app.sml.addSong.picked', defaultMessage: 'Picked' },
  save: { id: 'app.sml.addSong.save', defaultMessage: 'Add {title}' },
  outNote: {
    id: 'app.sml.addSong.out.note',
    defaultMessage: 'The cover and the facts come from the streaming services.',
  },
  errorNoMatch: { id: 'app.sml.addSong.error.noMatch', defaultMessage: 'No song found for "{query}".' },
  errorNoMatchBody: {
    id: 'app.sml.addSong.error.noMatch.body',
    defaultMessage: 'Check the spelling, or paste the song link from Spotify or Apple Music. Not out yet?',
  },
  errorNoMatchUnreleased: { id: 'app.sml.addSong.error.noMatch.unreleased', defaultMessage: 'Add it as unreleased' },
  // The search did not answer (QA 2026-10-28, mob-10): never "No song found".
  errorSearchFailed: { id: 'app.sml.addSong.error.searchFailed', defaultMessage: 'Search is not working right now.' },
  errorSearchFailedBody: {
    id: 'app.sml.addSong.error.searchFailed.body',
    defaultMessage: 'Paste the song link from Spotify or Apple Music, or type the song in.',
  },
  errorSearchRetry: { id: 'app.sml.addSong.error.searchFailed.retry', defaultMessage: 'Search again' },
  errorBadLink: {
    id: 'app.sml.addSong.error.badLink',
    defaultMessage: 'We cannot read this link. Paste a song link from Spotify, Apple Music, Deezer or YouTube.',
  },
  errorTooBig: {
    id: 'app.sml.addSong.error.tooBig',
    defaultMessage: 'This file is {size} MB. A cover can be up to {max} MB.',
  },
  errorWrongType: {
    id: 'app.sml.addSong.error.wrongType',
    defaultMessage: 'The cover must be a JPG, PNG or WebP image.',
  },
  errorUpload: { id: 'app.sml.addSong.error.upload', defaultMessage: 'We could not upload the cover. Try again.' },
  // The API refused the bytes of the file (QA brk-12): "Try again" with the same file never works.
  errorNotImage: {
    id: 'app.sml.addSong.error.notImage',
    defaultMessage: 'This file is not an image. Use a JPG, PNG or WebP picture.',
  },
  errorExists: { id: 'app.sml.addSong.error.exists', defaultMessage: '{title} is already in your catalog.' },
  errorExistsOpen: { id: 'app.sml.addSong.error.exists.open', defaultMessage: 'Open its release page' },
  errorSave: {
    id: 'app.sml.addSong.error.save',
    defaultMessage: 'We could not add the song. Your choices are still here. Try again.',
  },
  resolving: { id: 'app.sml.addSong.resolving', defaultMessage: 'Reading the link' },
  searching: { id: 'app.sml.addSong.searching', defaultMessage: 'Searching' },
});
